import { FC } from 'react';
import {
  FormControl,
  FormLabel,
  Input,
  Stack,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Button,
  Modal,
  Text,
} from '@chakra-ui/react';
import { useDeleteStore } from '../../hooks';

type Props = ReturnType<typeof useDeleteStore>;

export const EnvironmentDeleteModalView: FC<Props> = ({
  values,
  isOpenModal,
  onCloseModal,
  onDeleteEnvironment,
  componentList,
}) => (
  <Modal
    isOpen={isOpenModal}
    onClose={onCloseModal}
    size="2xl"
    blockScrollOnMount
  >
    <ModalOverlay />
    <ModalContent>
      <ModalHeader p="40px">環境の削除</ModalHeader>
      <ModalCloseButton />
      <ModalBody px="40px">
        <Stack spacing="6" direction="column">
          <FormControl>
            <FormLabel>環境名</FormLabel>
            <Input
              type="text"
              value={values.name}
              width="240px"
              variant="flushed"
              isReadOnly
              isTruncated
            />
          </FormControl>
          <FormControl>
            {values.components?.map((component) => (
              <Stack key={component.id}>
                <FormLabel>コンポーネント</FormLabel>
                <Stack pl="5">
                  <FormLabel>コンポーネント名</FormLabel>
                  {componentList.map(
                    (list) =>
                      component.id === list.id && (
                        <Stack key={list.id}>
                          <Input
                            type="text"
                            value={list.componentName}
                            variant="flushed"
                            isReadOnly
                          />
                        </Stack>
                      ),
                  )}
                  <FormLabel>バージョン</FormLabel>
                  <Input
                    type="text"
                    value={component.version}
                    variant="flushed"
                    isReadOnly
                  />
                </Stack>
              </Stack>
            ))}
          </FormControl>
        </Stack>
        <Text mt="60px" align="center" fontWeight="bold">
          上記の環境情報を削除しますか？
        </Text>
      </ModalBody>
      <ModalFooter gap="16px" justifyContent="center" p="40px">
        <Button
          w="140px"
          colorScheme="blackAlpha"
          variant="outline"
          onClick={onCloseModal}
        >
          キャンセル
        </Button>
        <Button colorScheme="red" onClick={onDeleteEnvironment} w="140px">
          削除
        </Button>
      </ModalFooter>
    </ModalContent>
  </Modal>
);
